export default "__VITE_ASSET__0d0b20ef__"